<template>
  <div>
    <FormItem
      :label="getLabel(data)"
      :if="data"
      :prop="fieldNameFormat(data.name)"
      :rules="getRuleByFieldData(data)"
    >
      <!-- field-info text -->
      <p
        class="field-info"
        v-if="data.helpText && data.fieldType != 'checkbox'"
        v-html="data.helpText"
      ></p>

      <!-- input case -->
      <template v-if="getFieldTag(data.fieldType, 'input')">
        <Input
          :name="fieldNameFormat(data.name)"
          v-model="registerFormData[fieldNameFormat(data.name)]"
          :type="getInputType(data.fieldType)"
          @on-blur="onChangeHandler"
        />
      </template>

      <!-- checkbox case -->
      <template v-else-if="getFieldTag(data.fieldType, 'checkbox')">
        <Checkbox
          v-model="registerFormData[fieldNameFormat(data.name)]"
          true-value="true"
          false-value
        >
          <span v-html="data.helpText"></span>
        </Checkbox>
      </template>

      <!-- country case -->
      <template v-else-if="data.fieldType === 'country'">
        <div class="native-select-wrapper">
          <select
            class="native-select"
            :name="fieldNameFormat(data.name)"
            v-model="registerFormData[fieldNameFormat(data.name)]"
            placeholder="Please select one"
            @on-change="onChangeHandler"
          >
            <option
              v-for="(country, index) in countries"
              :value="country"
              :key="index"
            >
              {{ country }}
            </option>
          </select>
          <i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
        </div>
      </template>

      <!-- selectbox -->
      <template v-else-if="data.fieldType === 'selectbox'">
        <div class="native-select-wrapper">
          <select
            class="native-select"
            :name="fieldNameFormat(data.name)"
            v-model="registerFormData[fieldNameFormat(data.name)]"
            placeholder="Please select one"
          >
            <option
              v-for="(option, index) in selectBoxOptions"
              :value="option"
              :key="index"
            >
              {{ option }}
            </option>
            <option v-if="data.selectBoxUseOther" value="other">
              {{ $t("regform_selectBoxOther") }}
            </option>
          </select>
          <i class="ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow"></i>
        </div>
      </template>
      <!-- html content -->
      <template v-else-if="data.htmlContent">
        <div class="html-content" v-html="data.htmlContent"></div>
      </template>
    </FormItem>

    <!-- selectbox other -->
    <template v-if="registerFormData[fieldNameFormat(data.name)] == 'other'">
      <FormItem
        :prop="fieldNameFormat(data.name) + '-other'"
        :rules="{ required: true, message: 'This field is required' }"
      >
        <Input
          :name="fieldNameFormat(data.name)"
          v-model="registerFormData[fieldNameFormat(data.name) + '-other']"
        />
      </FormItem>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import countries from './countries.json'
import $config from '@/config'
import logger from '@/api/logger'

String.prototype.turkishToUpper = function() {
  var string = this
  var letters = { i: 'İ', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç', ı: 'I' }
  string = string.replace(/(([iışğüçö]))/g, function(letter) {
    return letters[letter]
  })
  return string.toUpperCase()
}

export default {
  props: ['data', 'registerFormData', 'onChangeHandler'],
  data() {
    return {
      countries: countries.map(country => country.name),
      newFieldsMappings: {
        input: [
          'name',
          'name6',
          'last_name',
          'email',
          'event_password',
          'city',
          'phone',
          'short_text',
          'long_text',
          'number',
          'birth_year',
          'tcid',
          'tcidf'
        ],
        select: ['country'],
        checkbox: ['email_permission', 'checkbox']
      }
    }
  },
  computed: {
    selectBoxOptions() {
      return this.data.selectBoxOptions.split(',')
    }
  },
  methods: {
    getRuleByFieldData(data) {
      let rulesArray = []
      let rulesObject = {}

      // set default rules data
      if (data.required) {
        rulesObject = {
          required: true,
          message: this.$t('required_field_error'),
          trigger: 'blur'
        }
        rulesArray.push(rulesObject)
      }

      // set rules for "Checkbox" case
      if (data.fieldType === 'email') {
        rulesObject = {
          type: 'email',
          message: this.$t('invalid_field_error', { fieldName: data.name }),
          trigger: 'blur'
        }
        rulesArray.push(rulesObject)
      }

      if (data.fieldType === 'number') {
        let numberValidator = (rule, value) => {
          return new Promise((resolve, reject) => {
            if (parseInt(value)) {
              resolve()
            } else {
              reject()
            }
          })
        }

        rulesObject = {
          type: 'string',
          trigger: 'blur',
          validator: numberValidator
        }
        rulesArray.push(rulesObject)
      }

      if (data.fieldType === 'name6') {
        rulesObject = {
          type: 'string',
          trigger: 'blur',
          min: 6
        }
        rulesArray.push(rulesObject)
      }

      if (data.fieldType === 'tcid') {
        rulesObject = {
          validator: this.validateTCID,
          trigger: 'blur'
        }
        rulesArray.push(rulesObject)
      }

      if (data.fieldType === 'tcidf') {
        rulesObject = {
          validator: this.validateTCID2,
          trigger: 'blur'
        }
        rulesArray.push(rulesObject)
      }

      if (data.fieldType === 'html_content') {
      }

      return rulesArray
    },

    fieldNameFormat(fieldName) {
      if (fieldName) {
        return _.kebabCase(fieldName)
      }
    },

    getFieldTag(fieldType, htmlTag) {
      return this.newFieldsMappings[htmlTag].includes(fieldType)
    },

    getInputType(fieldType) {
      let inputType = 'text'
      if (fieldType == 'email') inputType = 'email'
      else if (fieldType == 'event_password') inputType = 'password'
      else if (fieldType == 'long_text') inputType = 'textarea'
      else if (fieldType == 'number') inputType = 'text'
      return inputType
    },

    getLabel(data) {
      if (!this.getFieldTag(data.fieldType, 'checkbox')) {
        return data.name
      } else {
        return ''
      }
    },

    validateTCID(rule, value, callback, registerFormData) {
      if (!value) {
        return callback(new Error('Lütfen bu alanı doldurunuz.'))
      }
      let num = Number.parseInt(value)
      setTimeout(() => {
        if (!Number.isInteger(num)) {
          callback(
            new Error('TC Kimlik Numarası sadece rakamlardan oluşmalıdır.')
          )
        } else {
          if (num.toString().length != 11) {
            callback(new Error('TC Kimlik Numarası 11 Haneli olmalıdır.'))
          } else {
            let data = {
              TCKimlikNo: value,
              Ad: this.registerFormData['ad'].turkishToUpper().trim(),
              Soyad: this.registerFormData['soyad'].turkishToUpper().trim(),
              DogumYili: this.registerFormData['dogum-yili'].trim()
            }
            logger.info({ message: 'validateTCID Data', logData: data })

            axios
              .post($config.feathersServer + '/tcidcheck2/', data)
              .then(res => {
                logger.info({ message: 'validateTCID Data', logData: res })
                if (res.data.TCKimlikNoDogrulaResult) {
                  callback()
                } else {
                  callback(
                    new Error(
                      'TC Kimlik Numaranız girdiğiniz bilgiler ile uyuşmuyor. Lütfen kontrol ediniz.'
                    )
                  )
                }
              })
          }
        }
      }, 100)
    },
    validateTCID2(rule, value, callback, registerFormData) {
      if (!value) {
        return callback(new Error('Lütfen bu alanı doldurunuz.'))
      }
      function tcnoKontrol(kimlikno) {
        kimlikno = kimlikno.toString()
        var uzunluk = /^[0-9]{11}$/.test(kimlikno)
        var toplamX1 = 0
        for (var i = 0; i < 10; i++) {
          toplamX1 += Number(kimlikno.substr(i, 1))
        }
        var kural1 = toplamX1 % 10 == kimlikno.substr(10, 1)
        var toplamY1 = 0
        var toplamY2 = 0
        for (var i = 0; i < 10; i += 2) {
          toplamY1 += Number(kimlikno.substr(i, 1))
        }
        for (var i = 1; i < 10; i += 2) {
          toplamY2 += Number(kimlikno.substr(i, 1))
        }
        var kural2 = (toplamY1 * 7 - toplamY2) % 10 == kimlikno.substr(9, 0)
        return uzunluk && kural1 && kural2
      }

      let num = Number.parseInt(value)
      if (tcnoKontrol(num)) {
        callback()
      } else {
        callback(new Error('Lütfen geçerli bir TC Kimlik Numarası Giriniz.'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-info {
  margin: 25px 0;
}

.field-info {
  width: 100%;
  clear: both;
  opacity: 0.6;
  line-height: 20px;
  margin-top: 24px;
}

.remove-field {
  padding: 7px 24px;
  border-left-color: transparent;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  &--checkbox {
    border: none;
    background-color: transparent;
  }
  &:focus {
    box-shadow: none;
  }
}
</style>

<style lang="scss">
.html-content {
  display: inline-block;
  width: 100%;
  line-height: 24px;
  font-size: 14px;
  letter-spacing: 0.4px;
  margin-top: 24px;
  li {
    margin-left: 24px;
    margin-bottom: 8px;
  }
}
.reg-form-item {
  .ivu-form-item-content {
    display: flex;
    flex-wrap: wrap;
    clear: both;

    .ivu-input-wrapper,
    .ivu-select {
      width: auto;
      flex: 1;
    }
  }
  .form-container {
    ul {
      padding-left: 0;
    }
  }
  .ivu-select-input {
    height: 36px;
  }
}

.ivu-checkbox-wrapper {
  line-height: 24px;
}

.native-select-wrapper {
  position: inherit;
  .ivu-select-arrow {
    pointer-events: none;
    transform: translate(0%, 50%);
    line-height: 10px;
  }
}

.native-select {
  display: block;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #dcdee2;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
  display: inline-block;
  line-height: 1.7;
  padding: 6px 8px 6px 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px !important;
  width: 100%;
  margin-top: 8px;
  color: #515a6e;
}
</style>

<style >
.ivu-checkbox-wrapper p:first-child {
  display: inline;
}
</style>
